/**
 * Conroo REST Frontend Backend
 * REST Interface for new Conroo backend for frontend app communication.
 *
 * OpenAPI spec version: v1.0.3
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { HttpFile } from '../http/http';

/**
* SealData
*/
export class SealData {
    'id'?: number;
    'number': string;
    'addedBy': SealDataAddedByEnum;

    static readonly discriminator: string | undefined = undefined;

    static readonly attributeTypeMap: Array<{name: string, baseName: string, type: string, format: string}> = [
        {
            "name": "id",
            "baseName": "id",
            "type": "number",
            "format": "int64"
        },
        {
            "name": "number",
            "baseName": "number",
            "type": "string",
            "format": ""
        },
        {
            "name": "addedBy",
            "baseName": "addedBy",
            "type": "SealDataAddedByEnum",
            "format": ""
        }    ];

    static getAttributeTypeMap() {
        return SealData.attributeTypeMap;
    }

    public constructor() {
    }
}


export type SealDataAddedByEnum = "trucker" | "terminal" | "forwarder_operator" ;

